import { React, useEffect, useState } from "react";
import styled from "styled-components";
import { getAllAdmin, deleteadminById } from "../../api/axios";
import "./admin.css";
import {useNavigate, useParams, Link} from "react-router-dom";
import { Alert, Button } from "react-bootstrap";
import CmsCircularProgress from "../Common/CircularProgress";
import { showToast } from "../../Utills/toast";
import CustomTable from "../Common/DataTable/DataTable";
import DeleteIcon from "../../Assets/delete.svg";

export default function Admin() {
    const { partnerId } = useParams();

    const [data, setData] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const res = await getAllAdmin();
        setData(res.data);
      } catch (err) {
        showToast({
          type: 'error',
          message: err.data.message || 'Failed to fetch admin data. Please try again.',
        });
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchData();
  }, []);

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowAlert(true);
  };

  const handleDeleteConfirm = async () => {
    setShowAlert(false);
    if (deleteId) {
      try {
        const res = await deleteadminById(deleteId);
        if (res.ok) {
          setData(data.filter((admin) => admin.id !== deleteId));
        } else {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    }
    // Show the success message
    showToast({
      type: 'success',
      message: 'Admin has been deleted successfully!',
    });
    window.location.reload()
    // Hide the confirmation alert
    setShowAlert(false);
  };

  const handleUpdateClick = (id) => {
    navigate(`update/${id}`);
    console.log("clicked");
  };

  const columns = [{
    text: "ID",
    width: "45px"
  },
  {
    text: "Name",
    width: "212px"
  },
  {
    text: "Email",
    width: "374px"
  },
  {
    text: "Function",
    width: "210px"
  }
  
];
const rows = [];

if(Array.isArray(data) && data.length > 0) {
  data.forEach((item) => {
    rows.push([
      item.id,
      item.admin_name,
      item.email,
      (
        <div style={{display: "flex", gap: "10px",justifyContent: "center"}}>
           <Button variant="primary" className='m-0 w-auto' onClick={() => handleUpdateClick(item.id)}>Edit</Button>
          <Button variant="danger" className="w-auto m-0" onClick={() => handleDeleteClick(item.id)}>Delete</Button>
        </div>
      )
    ]);
  });
}


  return (
    <>
    {isLoading ? <CmsCircularProgress/> :
    <ContentWrapper>
      <Title>Admin Details</Title>
      {/* <TableWrapper> */}
       <div className="d-flex mx-auto row-reverse" style={{maxWidth: "840px ", flexDirection: "row-reverse"}}>  
       <Link
         className="text-decoration-none mb-0"
            to={`/${partnerId}/admin/register`}
          >
            <Button className="FooterEdit m-0" variant="primary" type="submit">
              Register New Admin
            </Button>
          </Link>
        </div>
      {/* </TableWrapper> */}
        <CustomTable columns={columns} rows={rows} />
      <SliderDiv>
      
      </SliderDiv>

      <div
        className="overlay"
        style={{ display: showAlert ? "block" : "none" }}
      ></div>

      <Alert
        show={showAlert}
        variant="light"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxWidth: '400px',
          width: 'calc(100vw - 8vw)',
          height: "auto",
          zIndex: 1000,
        }}
      >
        <Alert.Heading style={{ textAlign: "center" }}>
        <div className="delete-icon-section">
              <img
                src={DeleteIcon}
                alt="delete"
              />
            </div>
          {/* Confirm Delete */}
        </Alert.Heading>
        <p className="fs-4 fw-semibold text-center text-black">
            Are you sure ?
        </p>
        <p className="text-center">
          This action will delete the admin and all the documents associated with them.
        </p>
        <div className="d-flex justify-content-end gap-2">
          <button className="btn btn-danger m-0  w-auto" onClick={handleDeleteConfirm}>
            Yes
          </button>
          <button
            className="btn btn-secondary m-0 w-auto"
            style={{ marginLeft: "1em" }}
            onClick={() => setShowAlert(false)}
          >
            No
          </button>
        </div>
      </Alert>
    </ContentWrapper>}
    </>
  );
}

const ContentWrapper = styled.div`
 @media (min-width:576px) {
    padding: 1rem;
    }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const Title = styled.h3`
  text-align: center;
`;
const SliderDiv = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;
const TableWrapper = styled.div`
 margin: 0 auto;
  overflow-x: auto;

  .textarea {
    box-sizing: fixed;
  }
`;

